import Script from 'next/script';
import React from 'react';

interface ISetUserIdProps {
  userId: string | null;
}

export const SetUserIdServerComponent: React.FC<ISetUserIdProps> = ({
  userId
}) => {
  return (
    <Script type="text/javascript" strategy="afterInteractive">
      {`window.ls('setUserId', ${userId ? `'${userId}'` : null});`}
    </Script>
  );
};
